import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "table table-bordered" }
const _hoisted_4 = { class: "bg-light" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = {
  colspan: "2",
  class: "text-capitalize-first text-center"
}
const _hoisted_9 = { class: "align-middle bg-white" }
const _hoisted_10 = {
  key: 0,
  class: "fa fa-eye-slash"
}
const _hoisted_11 = { class: "align-middle bg-white" }
const _hoisted_12 = { class: "bg-white" }
const _hoisted_13 = { class: "form-check form-switch d-flex align-items-center justify-content-center" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { style: {"width":"100px"} }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = { style: {"width":"100px"} }
const _hoisted_18 = ["value"]
const _hoisted_19 = { style: {"width":"100px"} }
const _hoisted_20 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "modalLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_4, [
                _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.traffic_group')), 1),
                _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.type')), 1),
                _cache[0] || (_cache[0] = _createElementVNode("th", {
                  class: "text-capitalize-first",
                  style: {"width":"0px"}
                }, null, -1)),
                _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.reward_fee_percent_short')), 1),
                _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.min_max_store_reward')), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedSettings, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.trafficGroupId,
                  class: _normalizeClass({'bg-warning': !_ctx.isValidRewards(item)})
                }, [
                  _createElementVNode("td", _hoisted_9, [
                    _createTextVNode(_toDisplayString(item._trafficGroup?.name) + " ", 1),
                    (item._trafficGroup?.isHidden)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.helper.trans(`direction.${item._trafficGroup?.type}`)), 1),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((item.enabled) = $event),
                        id: "autoclose",
                        class: "form-check-input",
                        style: {"cursor":"pointer"},
                        type: "checkbox",
                        role: "switch"
                      }, null, 8, _hoisted_14), [
                        [_vModelCheckbox, item.enabled]
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": ($event: any) => ((item._rewardPercent) = $event)
                    }, null, 8, _hoisted_16), [
                      [_vModelText, item._rewardPercent]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("input", {
                      class: "form-control form-control-sm",
                      readonly: "",
                      value: item._groupMinRewardPercent
                    }, null, 8, _hoisted_18)
                  ]),
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("input", {
                      class: "form-control form-control-sm",
                      readonly: "",
                      value: item._groupMaxRewardPercent
                    }, null, 8, _hoisted_20)
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}